export enum HealthAndSafetyRule{
  ClientTemperatureChecks = 'ClientTemperatureChecks',
  ContactlessPaymentAvailable = 'ContactlessPaymentAvailable',
  DisinfectionBetweenClients = 'DisinfectionBetweenClients',
  DisinfectionOfAllSurfacesInTheWorkspace = 'DisinfectionOfAllSurfacesInTheWorkspace',
  DisposableSuppliesInUse = 'DisposableSuppliesInUse',
  EmployeesWearDisposableGloves = 'EmployeesWearDisposableGloves',
  EmployeesWearMask = 'EmployeesWearMask',
  EmployeeTemperatureChecks = 'EmployeeTemperatureChecks',
  MaintainSocialDistancing = 'MaintainSocialDistancing',
  MaskProvidedForClients = 'MaskProvidedForClients',
  NoInteractionWithOtherClients = 'NoInteractionWithOtherClients',
  NoWaitingArea = 'NoWaitingArea',
  NoWalkIns = 'NoWalkIns',
  PlaceToWashHandsAvailable = 'PlaceToWashHandsAvailable',
  TimeGapBetweenAppointments = 'TimeGapBetweenAppointments'
}
